import React from "react";
import { Dialog, Popover } from "@mui/material";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { Col, Row } from "reactstrap";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { subHeadingStyle } from "../../../studentFinanceApproval/epmrCancellation/constant";
import { ReactComponent as WarningInfoCircle } from "assets/img/svg/warningInfoCircle.svg"

export const PopoverDropdown = ({
  dropdownMenu = [],
  setAnchorEl,
  anchorEl,
  paymentModeCollected = "",
  handleChange = () => { },
  accessiblePaymentModeList = [],
  checkReceiptCursor,
}) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover-dropdown" : undefined;
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <div style={{ padding: "16px", gap: "12px" }}>
        {dropdownMenu.map((item, index) => {
          return accessiblePaymentModeList.includes(item?.key) &&
            item?.key != "QRC" ? (
            <div
              className="global-font-size cursor"
              style={{ fontWeight: "400", lineHeight: "24px" }}
              key={index}
              onClick={() => {
                handleChange(item);
              }}
            >
              <div
                // className={
                //   paymentModeCollected
                //     ? paymentModeCollected == item?.key
                //       ? "d-flex cursor"
                //       : "d-flex cursor-not-allowed"
                //     : checkReceiptCursor(item)
                //     ? "d-flex cursor"
                //     : "d-flex cursor-not-allowed"
                // }
                className="d-flex cursor"
                style={item?.icon ? { gap: "12px" } : {}}
              >
                <span>{item?.icon}</span>
                <span>{item?.text}</span>
              </div>
            </div>
          ) : (
            ""
          );
        })}
      </div>
    </Popover>
  );
};

export const downLoadFile = async (download = true, s3Key, setFileUrl) => {
  const templateUrl = await fetchAllPostPromisedData(
    `${endpoint.fetchS3Url.getDownloadUrl}?key=${s3Key}`,
    {}
  );
  if (templateUrl?.code === 200 && templateUrl?.data) {
    if (!download) {
      setFileUrl(templateUrl?.data?.url);
    } else {
      window.open(`${templateUrl?.data?.url}`);
    }
  } else {
    failureToast("Something went wrong please try after sometime.");
  }
};

export const getConditionalCOllectSaveButton = (
  disabled,
  paymentModeForm,
  validatePayment = () => { },
  isReceiptEdit,
  isEditForm,
  isView,
  setModifyPaymentModeData,
  rowId,
  handleClose,
  isQRC = false
) => {
  const handleSave = () => {
    validatePayment();
  };

  return (
    <Row>
      <Col md={4}>
        {!isView && (
          <div className="mt-3" style={{ marginLeft: "-12px" }}>
            <AButton
              variant={"primary_filled"}
              updatedStyle={isReceiptEdit ? { width: "100%" } : {}}
              disabled={disabled || isQRC}
              onClick={() => {
                isReceiptEdit ? handleSave() : validatePayment();
              }}
            >
              {isEditForm || isReceiptEdit ? "Save" : "Collect Payment"}
            </AButton>
          </div>
        )}
      </Col>

      <Col md={4}>
        {!(
          paymentModeForm?.indexToEdit || paymentModeForm?.indexToEdit === 0
        ) &&
          isReceiptEdit && (
            <div className="mt-3" style={{ marginLeft: "-12px" }}>
              <AButton
                variant="outline"
                textColor="#262626"
                outlineVariantColor="#CBCBCB"
                updatedStyle={isReceiptEdit ? { width: "100%" } : {}}
                disabled={
                  !(
                    paymentModeForm?.paidAmount ||
                    paymentModeForm?.referenceNumber ||
                    paymentModeForm?.paymentModeDate ||
                    paymentModeForm?.bank ||
                    paymentModeForm?.paymentModeAttachmentS3Key
                  ) || isQRC
                }
                onClick={() => {
                  handleClose(false, true);
                }}
              >
                Reset
              </AButton>
            </div>
          )}
      </Col>
    </Row>
  );
};
export const WarningDialog = (
  {open=false,
  setOpen,
  confirmHandler,
  title,
  subheading}
) => {

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} fullWidth maxWidth ="sm">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          {/* <QuestionMarkIcon /> */}
          <WarningInfoCircle/>
          <CrossIcon onClick={closeDialog} />
        </div>
        <div style={{width:'440px'}}>
        <div className="header">{title}</div>
        <div style={subHeadingStyle}>{subheading}</div>
        <div className="mt-4">
          <button className="no-ml-btn" onClick={closeDialog}>
            Go back
          </button>
          <AButton
            variant="primary_filled"
            onClick={() => {
              confirmHandler()
              closeDialog()
            }}
          >
            Confirm
          </AButton>
        </div>
            </div>
      </div>
    </Dialog>
  );
};
